import React, { useRef, useEffect, RefObject } from 'react';

import FadeIn from 'src/components/elements/FadeIn';

import { S3_IMAGES_URL } from '../../constants';

import { useInView } from 'framer-motion';

import styles from './BeansBlock.scss';

const BeansBlock = () => {
  const ref: RefObject<HTMLDivElement> = useRef(null);
  const inViewport = useInView(ref);

  const parallax = (e): void => {
    const beans: NodeListOf<HTMLImageElement> = document.querySelectorAll('#bean');

    beans.forEach((bean) => {
      const speed: number = parseInt(bean.getAttribute('data-speed')!, 10);

      if (typeof window !== 'undefined') {
        const x = (window.innerWidth - e.pageX * speed) / 100;
        const y = (window.innerHeight - e.pageY * speed) / 100;

        bean.style.transform = `rotate(30deg) scale(1.2) translateX(${x}px) translateY(${
          y + 55
        }px)`;
        bean.style.transition = 'all 0.2s';
      }
    });
  };

  useEffect(() => {
    document.addEventListener('mousemove', parallax);

    if (!inViewport) {
      document.removeEventListener('mousemove', parallax);
    }

    return () => {
      document.removeEventListener('mousemove', parallax);
    };
  }, [inViewport]);

  return (
    <div ref={ref} className={styles.beansBlock}>
      <div className={styles.title}>
        <FadeIn>
          <span>Dream up</span>
        </FadeIn>
        <FadeIn delay={1}>
          <span className={styles.titleThin}>your next trip</span>
        </FadeIn>
      </div>

      <div className={styles.beans}>
        <div className={styles.bean}>
          <img
            id="bean"
            data-speed={2}
            src={`${S3_IMAGES_URL}beans_block/bean-1.webp`}
            alt="bean-image"
          />
        </div>
        <div className={styles.bean}>
          <img
            id="bean"
            data-speed={2}
            src={`${S3_IMAGES_URL}beans_block/bean-2.webp`}
            alt="bean-image"
          />
        </div>
        <div className={styles.bean}>
          <img
            id="bean"
            data-speed={2}
            src={`${S3_IMAGES_URL}beans_block/bean-3.webp`}
            alt="bean-image"
          />
        </div>
      </div>
    </div>
  );
};

export default BeansBlock;
